import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/custom-bootstrap.scss';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
//import awsExports from './aws-exports'; // generated by `amplify pull`

//Amplify.configure(awsExports);

const { 
  REACT_APP_REGION,
  REACT_APP_USER_POOL_ID,
  REACT_APP_USER_POOL_CLIENT_ID
} = process.env;

if (!REACT_APP_REGION || !REACT_APP_USER_POOL_ID || !REACT_APP_USER_POOL_CLIENT_ID) {
  // surface a clear error during dev/build
  // (the ! non-null assertions hide the real issue)
  console.error('Missing Amplify Auth env vars', {
    REACT_APP_REGION, REACT_APP_USER_POOL_ID, REACT_APP_USER_POOL_CLIENT_ID
  });
}

Amplify.configure({
  Auth: {
    region: REACT_APP_REGION!,
    userPoolId: REACT_APP_USER_POOL_ID!,
    userPoolWebClientId: REACT_APP_USER_POOL_CLIENT_ID!,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
